import { Box, Radio } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type RoleSectionType = 'factorial_roles' | 'default_job_position'

interface RolesRadiobuttonsProps {
  roleSectionType: RoleSectionType
  onRoleSectionTypeChange: (type: RoleSectionType) => void
}

export const RolesRadiobuttons = ({
  roleSectionType,
  onRoleSectionTypeChange,
}: RolesRadiobuttonsProps) => {
  return (
    <Box gap="s8">
      <Radio
        name="factorial_roles"
        option={{
          label: i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.levels.section_type.factorial_roles.button'
          ),
          value: 'factorial_roles',
          disabled: false,
        }}
        value={roleSectionType}
        onChange={() => onRoleSectionTypeChange('factorial_roles')}
      />
      <Radio
        name="default_job_position"
        option={{
          label: i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.levels.section_type.default_job_position.button'
          ),
          value: 'default_job_position',
          disabled: false,
        }}
        value={roleSectionType}
        onChange={() => onRoleSectionTypeChange('default_job_position')}
      />
    </Box>
  )
}
